<template>
  <div class="vh100 login-bgcolor">
    <div class="top-vh">
      <div style="height: 40%"></div>
      <div>
        <div class="login-logo-pos">
          <van-row type="flex" justify="center">
            <img class="login-logo" src="../assets/logo.png" alt />
          </van-row>
        </div>
        <div class="login-title-pos">
          <van-row type="flex" justify="center">
            <van-col class="login-title">遛遛游戏商城</van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div v-if="1 == 0">
      <div class="login-form-pos">
        <van-row type="flex" justify="center">
          <van-form
            @submit="login"
            class="login-form"
            :show-error="false"
            validate-trigger="onSubmit"
          >
            <van-field
              class="login-form-field border-radius"
              v-model="mobile"
              left-icon="phone-o"
              center
              clearable
              placeholder="请输入手机号码"
              :rules="[{ required: true, message: '请输入手机号码' }]"
            >
              <template #button>
                <van-button
                  class="border-radius"
                  size="small"
                  type="info"
                  native-type="button"
                  :disabled="!mobile || overSeconds > 0"
                  @click="applyVerifyCode"
                  >{{ countdownText }}</van-button
                >
              </template>
            </van-field>

            <van-field
              class="login-form-field border-radius verify-vh"
              v-model="code"
              left-icon="comment-o"
              center
              clearable
              placeholder="请输入验证码"
              :rules="[{ required: true, message: '请输入验证码' }]"
            >
            </van-field>
            <div>
              <van-button
                class="border-radius"
                block
                type="info"
                native-type="submit"
                >登录</van-button
              >
            </div>
          </van-form>
        </van-row>
      </div>
    </div>
    <div v-if="1 == 1" class="flex flex-a-c justify-content">
      <div style="width: 90%">
        <!-- 微信登录按钮 -->
        <van-button type="primary" block round @click="handleWxLogin">
          <div class="flex flex-a-c">
            <van-icon name="wechat" class="wechat-icon size24" />
            <div class="mrgl10">微信登录</div>
          </div>
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ApplyVerifyCode,
  LoginMobile,
  GetWxLoginSetting,
} from "../api/mallapi.js";
import { wxLogin } from "@/utils/wxAuth";
export default {
  name: "Login_bak",
  data() {
    return {
      mobile: "",
      code: "",
      prePath: "",

      overSeconds: "",
      sending: false,
    };
  },
  computed: {
    // 倒计时显示文本
    countdownText() {
      if (this.overSeconds > 0) {
        return `${this.overSeconds}秒后重新获取`;
      }
      return this.sending ? "发送中..." : "获取验证码";
    },
  },
  methods: {
    applyVerifyCode() {
      this.sending = true;
      this._applyVerifyCode()
        .then((res) => {
          this.$toast.success("验证码已发送");
          this.startCountdown();
        })
        .finally((e) => {
          this.sending = false;
        });
    },
    login() {
      this._loginMobile().then((res) => {
        localStorage.setItem(
          "userInfo",
          JSON.stringify({
            accountId: res.fullInfo.accountInfo.accountId,
            logonId: res.guid,
            account_no: res.fullInfo.accountInfo.number,
            loginType: 2,
          })
        );

        if (this.prePath) {
          this.$router.push(this.prePath);
        } else {
          this.$router.replace({
            name: "Mall",
          });
        }
      });
    },

    // 开始倒计时
    startCountdown() {
      if (this.overSeconds > 0) {
        this.timer = setInterval(() => {
          this.overSeconds--;

          if (this.overSeconds <= 0) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    async handleWxLogin() {
      var tmpInfo = await this._getWxLoginSetting();

      const currentUrl = tmpInfo.redirect_url;
      // 跳转微信授权页
      wxLogin(tmpInfo.appId, currentUrl);

      // 注意：跳转后本页面会卸载，isLoading状态无需重置
    },

    //申请手机验证码
    _applyVerifyCode() {
      var par = {
        phone: this.mobile,
      };
      return ApplyVerifyCode(par).then((res) => {
        this.overSeconds = res.overSeconds;
      });
    },
    //手机验证码登录
    _loginMobile() {
      var par = {
        phone: this.mobile,
        code: this.code,
      };
      return LoginMobile(par);
    },
    //获取微信登录接口配置信息
    _getWxLoginSetting() {
      var par = {};
      return GetWxLoginSetting();
    },
  },
  mounted() {
    this.prePath = this.$route.query.prePath;
  },
};
</script>

<style scoped>
.top-vh {
  height: 50%;
}
.login-bgcolor {
  background: #f7f8fa;
}
.login-logo-pos {
}
.login-logo {
  width: 2.5rem;
  height: 2.5rem;
}
.login-title-pos {
  margin-top: 10px;
}
.login-title {
  font-size: 24px;
}
.login-form-pos {
}
.login-form {
  width: 8rem;
}
.login-form-field {
  margin-bottom: 20px;
}
.verify-vh {
  height: 53px;
}
.border-radius {
  border-radius: 12px !important;
  overflow: hidden;
}
</style>